import { MajorProgram } from '../../../src/data/builders/major_programs_builder';
import { ICoursePlanStateParams } from '../../../src/major_explorer_interface';

export class MajorCourseMapController {
  private major: MajorProgram;

  constructor(private $stateParams: ICoursePlanStateParams) {
    this.major = this.$stateParams.selectedMajor;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/views/major_course_map/major_course_map_controller.ts